import { HTTP_API_V2 } from '../../http-common'

export default {
  state: {
    loadedInobramxWaterConsumption: []
  },
  getters: {
    loadedInobramxWaterConsumption (state) {
      return state.loadedInobramxWaterConsumption
    }
  },
  mutations: {
    setLoadedInobramxWaterConsumption (state, payload) {
      state.loadedInobramxWaterConsumption = payload
    },
    clearLoadedInobramxWaterConsumption (state) {
      state.loadedInobramxWaterConsumption = []
    }
  },
  actions: {
    fetchInobramxWaterConsumption ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedInobramxWaterConsumption', [])
      return new Promise((resolve, reject) => {
        HTTP_API_V2.get('inobramx/performance', {
          params: {
            mac: payload.mac || null,
            granularity: 'daily',
            metric: 'h2o',
            initial_date: payload.initial_date || null,
            final_date: payload.final_date || null
          }
        })
          .then(result => {
            const sortedData = result.data.sort((a, b) => a.age - b.age)
            commit('setLoadedInobramxWaterConsumption', sortedData)
            resolve(sortedData)
          })
          .catch(err => {
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedInobramxWaterConsumption ({ commit }) {
      commit('clearLoadedInobramxWaterConsumption')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/inobramx_performance/index.js